import { memo } from 'react';
import ThreatListStatusBadge from '../../../common/components/ThreatListStatusBadge';
import {
  getStatusColor,
  getStatusIcon,
  getStatusLabel,
} from '../../../common/utils/constants-getters';
import type {
  CellThreatDetailProps,
  ThreatStatusUnion,
} from '../../../threat.types';

export type StatusCellProps = {
  status: ThreatStatusUnion;
};

export const StatusCell = memo(({ status }: StatusCellProps) => (
  <ThreatListStatusBadge
    color={getStatusColor(status)}
    icon={getStatusIcon(status)}
  >
    {getStatusLabel(status)}
  </ThreatListStatusBadge>
));

export const renderStatusCell = (
  info: CellThreatDetailProps<ThreatStatusUnion>,
) => {
  const status = info.getValue();
  if (!status) return '-';

  return <StatusCell status={status} />;
};
